"use strict";
import gsap from "gsap";

const Modal = {
  triggers: [],
  init: function () {
    Modal.triggers = document.querySelectorAll(".open-modal");

    if (Modal.triggers.length) {
      Modal.triggers.forEach((trigger) => {
        let id = trigger.getAttribute("aria-controls");
        let modal = document.querySelector(`.c-modal[id="${id}"]`);

        if (modal) {
          let modalBg = modal.querySelector(".c-modal__bg");
          let modalPannel = modal.querySelector(".c-modal__pannel");
          let closeBtn = modal.querySelector(".modal-close");

          if (modalBg && modalPannel && closeBtn) {
            trigger.addEventListener("click", () => {
              Modal.animateSlideIn(modalBg, modalPannel, closeBtn);
              trigger.ariaExpanded = true;
              window.addEventListener("keydown", (e) =>
                Modal.trapFocus(e, modalPannel, closeBtn)
              );
            });

            closeBtn.addEventListener("click", () => {
              Modal.animateSlideOut(modalBg, modalPannel, trigger);
              if (modalPannel.querySelector("video")) {
                modalPannel
                  .querySelectorAll("video")
                  .forEach((video) => video.pause());
              }
              window.removeEventListener("keydown", Modal.trapFocus);
            });

            modalBg.addEventListener("click", () => {
              Modal.animateSlideOut(modalBg, modalPannel, trigger);
              if (modalPannel.querySelector("video")) {
                modalPannel
                  .querySelectorAll("video")
                  .forEach((video) => video.pause());
              }
              window.removeEventListener("keydown", Modal.trapFocus);
            });

            window.addEventListener("resize", () => {
              Modal.animateSlideOut(modalBg, modalPannel, trigger);
              if (modalPannel.querySelector("video")) {
                modalPannel
                  .querySelectorAll("video")
                  .forEach((video) => video.pause());
              }
              window.addEventListener("keydown", Modal.trapFocus);
            });
          }
        }
      });
    }
  },
  animateSlideIn: function (background, pannel, closeBtn = null) {
    document.body.classList.add("no-scroll--");

    gsap.to(background, {
      left: 0,
      duration: 0,
    });
    gsap.to(background, {
      backdropFilter: "blur(20px)",
      duration: 0.2,
    });
    gsap.to(pannel, {
      right: 0,
      autoAlpha: 1,
      delay: 0.2,
      duration: 0.4,
      // onComplete: () => {
      //   if (closeBtn) {
      //     closeBtn.focus();
      //   }
      // },
    });
  },
  animateSlideOut: function (background, pannel, openBtn = null) {
    const width = getComputedStyle(pannel).width;

    gsap.to(pannel, {
      right: `-${width}`,
      autoAlpha: 0,
      duration: 0.4,
      ease: "power2.out",
    });
    gsap.to(
      background,
      {
        backdropFilter: "blur(0px)",
        duration: 0.2,
        delay: 0.2,
      },
      "< += 0.1"
    );
    gsap.to(background, {
      left: "100vw",
      delay: 0.4,
      duration: 0,
      onComplete: () => {
        if (openBtn) {
          // openBtn.focus();
          openBtn.ariaExpanded = false;
        }
      },
    });

    document.body.classList.remove("no-scroll--");
  },
  trapFocus: function (e, pannel, closeBtn) {
    let isEscPressed = e.key === "Escape" || e.keyCode === 27;
    if (isEscPressed) {
      closeBtn.click();
      return;
    }

    let isTabPressed = e.key === "Tab" || e.keyCode === 9;
    if (!isTabPressed) return;

    const focusableElts = pannel.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    );

    const firstFocusableElt = focusableElts[0];
    const lastFocusableElt = focusableElts[focusableElts.length - 1];

    // Back tab
    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElt) {
        lastFocusableElt.focus();
        e.preventDefault();
      }
    }
    // Forward tab
    else {
      if (document.activeElement === lastFocusableElt) {
        firstFocusableElt.focus();
        e.preventDefault();
      }
    }
  },
};

export default Modal;
